import { HiOutlinePencil, HiSwitchHorizontal } from "react-icons/hi";
import { useTranslation } from "react-i18next";

type WorkspaceCardProps = {
  name: string;
  isCurrent?: boolean;
  onSwitch?: () => void;
  onEdit?: () => void;
};

export const WorkspaceCard = ({
  name,
  isCurrent,
  onSwitch,
  onEdit,
}: WorkspaceCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex  w-[490px] items-center justify-between rounded-lg border bg-white px-6 py-4 shadow-md ${
        isCurrent ? "border-brand-500 ring-2 ring-brand-200" : "border-gray-200"
      }`}
    >
      <span className="flex-1 truncate text-lg font-medium text-gray-800">
        {name}
      </span>

      <div className="ml-4 flex flex-shrink-0 items-center gap-2">
        {isCurrent && (
          <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-800">
            {t("workspaces.card.current")}
          </span>
        )}
        {onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className="flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
          >
            <HiOutlinePencil className="h-5 w-5 text-gray-500" />
            {t("workspaces.card.edit")}
          </button>
        )}
        {!isCurrent &&
          onSwitch && (
            <button
              type="button"
              onClick={onSwitch}
              className="flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
            >
              <HiSwitchHorizontal className="h-5 w-5 text-gray-500" />
              {t("workspaces.card.switch")}
            </button>
          )}
      </div>
    </div>
  );
};
